import React from 'react';
import { PdfIcon, DocxIcon, XlsxIcon, Mp4Icon, ImageIcon, ZipIcon } from './icons';

export interface FileTypeInfo {
    icon: React.FC<React.SVGProps<SVGSVGElement>>;
    backgroundColor: string;
}

/**
 * Get file type information (icon and background color) based on file extension
 */
export const getFileTypeInfo = (filename: string): FileTypeInfo => {
    const extension = filename.toLowerCase().split('.').pop() || '';

    // PDF files
    if (extension === 'pdf') {
        return {
            icon: PdfIcon,
            backgroundColor: '#fee2e2', // red-100
        };
    }

    // Document files (Word)
    if (extension === 'doc' || extension === 'docx') {
        return {
            icon: DocxIcon,
            backgroundColor: '#dbeafe', // blue-100
        };
    }

    // Spreadsheet files (Excel)
    if (extension === 'xls' || extension === 'xlsx') {
        return {
            icon: XlsxIcon,
            backgroundColor: '#dcfce7', // green-100
        };
    }

    // Video files
    if (extension === 'mp4' || extension === 'mov' || extension === 'avi' || extension === 'wmv' || extension === 'mkv') {
        return {
            icon: Mp4Icon,
            backgroundColor: '#f3e8ff', // purple-100
        };
    }

    // Image files
    if (
        extension === 'png' ||
        extension === 'jpg' ||
        extension === 'jpeg' ||
        extension === 'gif' ||
        extension === 'bmp' ||
        extension === 'svg' ||
        extension === 'webp'
    ) {
        return {
            icon: ImageIcon,
            backgroundColor: '#ffedd5', // orange-100
        };
    }

    // Archive files
    if (extension === 'zip' || extension === 'rar' || extension === '7z' || extension === 'tar' || extension === 'gz') {
        return {
            icon: ZipIcon,
            backgroundColor: '#f1f5f9', // slate-100
        };
    }

    // Default/fallback for unknown file types
    return {
        icon: ZipIcon, // Use zip icon as generic file icon
        backgroundColor: '#f1f5f9', // slate-100
    };
};
